/**
 * GscBadge — small pill indicating a goal is auto-synced from Google
 * Search Console. Parallel to HsBadge for HubSpot-synced goals.
 *
 * Tooltip shows the as-of timestamp when provided, so users know how
 * fresh the data is.
 */
export default function GscBadge({ asOf, impressions, clicks }) {
  const title = asOf
    ? `Auto-synced from Google Search Console · last updated ${new Date(
        asOf
      ).toLocaleString()}${
        impressions != null
          ? ` · ${impressions.toLocaleString()} impressions, ${clicks.toLocaleString()} clicks (last 7d)`
          : ''
      }`
    : 'Auto-synced from Google Search Console'

  return (
    <span
      title={title}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 3,
        background: '#ecfeff',
        color: '#0e7490',
        border: '1px solid #a5f3fc',
        borderRadius: 4,
        padding: '1px 6px',
        fontSize: 9,
        fontWeight: 800,
        letterSpacing: 0.04,
        textTransform: 'uppercase',
        lineHeight: 1.4,
        userSelect: 'none',
        whiteSpace: 'nowrap',
      }}
    >
      🔍 GSC
    </span>
  )
}
